// import digitalIcon from '../assets/digitalIcon.png';
// import textIcon from '../assets/textIcon.png';
// import picIcon from '../assets/picIcon.png';
// import videoIcon from '../assets/videoIcon.png';

const videoIcon = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-1-S.png';
const picIcon = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-2-S.png';
const textIcon = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-3-S.png';
const digitalIcon = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-4-S.png';

const videoGif = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-1-M.gif';
const picGif = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-2-M.gif';
const textGif = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-3-M.gif';
const digitalGif = 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/Icon-4-M.gif';

export const navList = [
    {
        title: '视频',
        desc: '一键生成营销视频',
        width: 230,
        icon: videoIcon,
        gif: videoGif
    },
    {
        title: '图片',
        desc: '优质图片一键生成',
        width: 230,
        icon: picIcon,
        gif: picGif
    },
    {
        title: '文案',
        desc: '多类型场景文案生成',
        width: 246,
        icon: textIcon,
        gif: textGif
    },
    {
        title: '数字人',
        desc: '形象、语音高质量复刻',
        width: 262,
        icon: digitalIcon,
        gif: digitalGif
    }
];

export const contentList = [
    {
        title: '一键成片',
        desc: '一键生成营销视频，基于提示和素材，支持自定义输入，快速制作成片',
        wiseDesc: '国内领先AIGC技术。丰富的数字人模特+专属行业模板等，3分钟实现口播视频制作',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/home-video-v2-new.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'MashupCreateV2',
        icon: videoIcon,
        gif: videoGif
        // buttonList: [
        //     {
        //         text: '一键成片',
        //         routeName: 'MashupCreateV2'
        //     },
        //     {
        //         text: '专业编辑器',
        //         routeName: 'VideoTemplateV2'
        //     }
        // ]
    },
    {
        title: '一键出图',
        desc: '快速生成底图，支持自定义输入，叠加营销海报效果，一站式设计服务',
        wiseDesc: '支持文图生成和海报制作等能力，精准满足广告主诉求。实现AIGC营销场景的完美结合',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/home-image-v2-new.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        anyMatch: {
            allowInnerUser: true,
            authorizedRole: ['digital_education_image']
        },
        routeName: 'marketImageCreateV2',
        icon: picIcon,
        gif: picGif
        // buttonList: [
        //     {
        //         text: '一键生图',
        //         routeName: 'marketImageCreate'
        //     }, {
        //         text: '智能扩图',
        //         routeName: 'aiExpandImage'
        //     }
        // ]
    },
    {
        title: '一键生文',
        desc: '快速创作文案，满足个性化表达需求，创意与定制化兼备',
        wiseDesc: '专注营销广告领域，覆盖信息流、搜索等场景。以丰富、开放的方式满足文案定制需求',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/home-text-v2-new.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'textCreateTitleV2',
        icon: textIcon,
        gif: textGif
        // buttonList: [
        //     {
        //         text: '搜索广告文案',
        //         routeName: 'textCreateFc'
        //     }, {
        //         text: '信息流广告文案',
        //         routeName: 'textCreateFeed'
        //     }
        // ]
    },
    {
        title: '形象定制',
        desc: '打造1:1真人虚拟数字分身，实现高清个性化的数字形象',
        wiseDesc: '国内领先AIGC技术。丰富的数字人模特+专属行业模板等，3分钟实现口播视频制作',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/images/home/home-digital-v2-new.mp4',
        authorizedRole: 'digital_human_list',
        routeName: 'HumanCreateV2',
        icon: digitalIcon,
        gif: digitalGif
        // buttonList: [
        //     {
        //         text: '形象定制',
        //         routeName: 'HumanCreateV2'
        //     }, {
        //         text: '语音复刻',
        //         routeName: 'VoiceCreateV2'
        //     }
        // ]
    }
];

export const linkList = [
    {
        title: '营销资源',
        children: [
            {
                target: 'https://yingxiao.baidu.com/new/topic/641/',
                name: '百度APP'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/644/',
                name: '百度贴吧'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/642/',
                name: '好看视频'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/634/',
                name: '百青藤'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/643/',
                name: '百度地图'
            },
            {
                target: 'https://yingxiao.baidu.com/new/topic/640/',
                name: '百度聚屏'
            }
        ]
    },
    {
        title: '投放平台',
        children: [
            {
                target: 'https://tuiguang.baidu.com/',
                name: '效果广告投放平台'
            },
            {
                target: 'https://pinpai.baidu.com/',
                name: '品牌广告投放平台'
            }
        ]
    },
    {
        title: '相关营销服务',
        children: [
            {
                target: 'https://qingduo.baidu.com/co-extension-plan',
                name: '共拓计划'
            },
            {
                target: 'https://wutong.baidu.com/platform/',
                name: '基木鱼'
            },
            {
                target: 'https://cdp.baidu.com/',
                name: '观星盘'
            },
            {
                target: 'https://tongji.baidu.com/',
                name: '百度统计'
            },
            {
                target: 'https://b2bwork.baidu.com/',
                name: '爱采购'
            },
            {
                target: 'https://link.baidu.com/',
                name: '度星选'
            },
            {
                target: 'https://yingxiao.baidu.com/edu',
                name: '百度营销学堂'
            },
            {
                target: 'https://e.baidu.com/lp/tongyong7/?refer=1331',
                name: '企业推广'
            }
        ]
    },
    {
        title: '联系我们',
        children: [
            {
                name: 'sy-aigc-cy@baidu.com'
            }
        ]
    }
];
